import { createReducer, on } from '@ngrx/store';
import { initialReviewHistoryState, ReviewHistoryState } from './review-history.state';
import * as ReviewHistoryActions from './review-history.actions';

export const reviewHistoryReducer = createReducer(
  initialReviewHistoryState,
  
  // Load review history - keep old data during loading (optimistic UI)
  on(ReviewHistoryActions.loadReviewHistory, (state): ReviewHistoryState => ({
    ...state,
    loading: true,
    error: null,
    // Keep existing reviewHistory data visible during loading
  })),
  
  on(ReviewHistoryActions.loadReviewHistorySuccess, (state, { reviewHistory }): ReviewHistoryState => ({
    ...state,
    reviewHistory,
    loading: false,
    error: null,
  })),
  
  on(ReviewHistoryActions.loadReviewHistoryFailure, (state, { error }): ReviewHistoryState => ({
    ...state,
    loading: false,
    error,
  })),
  
  // Clear action removed - using optimistic UI pattern instead
  // Old data remains visible until new data loads
  
  // Refresh review history (same as load)
  on(ReviewHistoryActions.refreshReviewHistory, (state): ReviewHistoryState => ({
    ...state,
    loading: true,
    error: null,
  }))
);